<h1>Counter</h1>

<div>
    <span>The count is: {{ count() }}.</span>
    <button (click)="decrement()">-</button>
    <button (click)="increment()">+</button>
</div>

<div>Double count is: {{ doubleCount() }}</div>
